import React from "react"
import cn from "classnames"
import * as s from "./footer.module.less";
import { Link } from 'gatsby-plugin-react-i18next';
import logo from "../../../media/logo/tpx_s_orange.png"
import logo_white from "../../../media/logo/tpx_s_white.png"
import * as landingPageStyle from "../landing-page.module.less"
const Footer = ({
  socialIcons,
  links,
  address,
  phone,
  mobile,
  isDark = false,
}) => {
  return (
    <footer className={ cn(s.footer, {
      [s.dark]: isDark
    }) }>
      <div className={ cn(landingPageStyle.container, s.row) }>
        <div className={ cn(s.col, s.leftAligned) }>
          <p className={ s.followText }>FOLLOW US</p>
          <div className={ s.socialIcons }>
            {socialIcons.map((element, i) => (
              <a
                  className={ s.icon }
                  key={ `social-icon-${i}-${element.href}` }
                  href={ element.href }
              >
                  { element.icon }
              </a>
            ))}
          </div>
          <div className={ s.links }>
            {[...links,
				{
					text: "Imprint",
					href: "/imprint"
				}
			].map((link) => (
              <Link
                to={link.href}
                key={`link-${link.href}`}
                activeClassName={ s.activeLink }
                className={ s.link }
              >
                {link.text}
              </Link>
            ))}
          </div>
        </div>
        <div className={ s.col }></div>
        <div className={ cn(s.col, s.rightAligned) }>
          <Link to={`/`} className={ s.logo }>
            <img
                alt={"Logo of TeamParallax"}
                src={isDark ? logo_white : logo}
            />
          </Link>
          <p className={ s.address }>Address: { address }</p>
          <p>Phone: { phone }</p>
			{mobile && <p>Mobile: { mobile }</p>}
        </div>
      </div>
    </footer>
  )
}
export default Footer
